export const WHATSAPP_NUMBER = '5575981872440';

const wa = (msg) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;

export const WHATSAPP_URL        = wa('Olá, vim do site de hiperidrose e gostaria de agendar uma consulta com dr. Mateus');
export const WHATSAPP_URL_CONV   = wa('Olá, vim do site de hiperidrose e gostaria de saber se dr. Mateus atende o meu convênio');
export const WHATSAPP_URL_PROC   = wa('Olá, vim do site e gostaria de saber mais sobre a Simpatectomia');
export const INSTAGRAM_URL       = 'https://instagram.com/drmateus_cirtorax';
export const DOCTOR_PHOTO_HERO = 'https://customer-assets.emergentagent.com/job_simpatectomia-feira/artifacts/yd7yn43y_AMO%20161%20-%20co%CC%81pia.JPG';
export const DOCTOR_PHOTO_ABOUT = 'https://customer-assets.emergentagent.com/job_simpatectomia-feira/artifacts/htkofdla_AMO%20173%20-%20co%CC%81pia.JPG';
export const LOGO_WITH_NAME = '/images/logo_with_name.png';
export const LOGO_ONLY = 'https://customer-assets.emergentagent.com/job_simpatectomia-feira/artifacts/ujw9x9g6_Logotipo.PNG';
